<template>
  <div class="app">
    <h1>{{ title }}</h1>
    <Header :activeIndex="'9'" />

    <div class="margintop">
      <div class="tiaozhuan"><span style="cursor: pointer;" @click="pathIndex">首页</span><span>&nbsp;&gt;&gt;&nbsp;</span><span style="cursor: pointer;"
          @click="pathxueyuan">老板学院</span><span>&nbsp;&gt;&gt;&nbsp;</span><span>知识详情</span></div>
      <div class="titlecss">{{ title }}</div>
      <div style="margin-left:auto;margin-right: auto;">
        <div v-html="formattedContent" style="text-align:left;"></div>
      </div>

      <div style="text-align:left;" v-if="beforefont !== 'null' && beforefont !== null">
        关键词：{{ beforefont }}
      </div>

      <div style="text-align: left;margin-top:0.7em;">
        <span v-if="previousId != 'null' && previousId != 0" @click="fetchPathPreviousId(previousId)">上一篇：{{
          previousTitle
        }}</span><br>
        <span v-if="nextId != 'null' && nextId != 0" @click="fetchPathNextId(nextId)">下一篇：{{ nextTitle }}</span><br>
        <span style="cursor: pointer;" @click="pathIndex">返回首页</span>
      </div>

      <div style="margin-bottom: 50px;"></div>
    </div>

    <Footer />

  </div>
</template>
  
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'xinwen',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      formattedContent: '',
      title: '',
      beforefont: '',
      image: 'https://mingqicaiwu.com:9001/mingqi/thumbnail.jpg',
      id: 0,
      previousId: 0,
      previousTitle: '',
      nextId: 0,
      nextTitle: ''
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
  },
  metaInfo() {
    return {
      title: this.title || this.getDefaultTitle(),
      meta: [
        { property: 'og:title', content: this.title || this.getDefaultTitle(), },
        { property: 'og:image', content: this.image || 'https://mingqicaiwu.com:9001/mingqi/thumbnail.jpg' },
        { property: "og:description", content: this.title || this.getDefaultTitle() }
      ]
    };
  },
  created() {
    this.id = this.$route.query.id;
    const id = this.$route.query.id;
    // this.nextId = this.$route.query.nextId;
    // this.previousId = this.$route.query.previousId;
    this.fetchDataById(id)
  },
  methods: {
    getDefaultTitle() {
      fetch('https://mingqicaiwu.com:8201/admin/news/selectById', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${this.id}`
      })
        .then(response => response.json())
        .then(data => {
          return data.title
        })
        .catch(error => {
          console.error("查询出错，原因是", error);
        });
    },
    fetchTwoId(id) {
      // 根据 id 查询数据的逻辑
      fetch('https://mingqicaiwu.com:8201/admin/news/getTwoId', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${id}`
      })
        .then(response => response.json())
        .then(data => {
          console.log("data", data);
          if (data.previousId != null) {
            this.previousId = data.previousId.id
            this.previousTitle = data.previousId.title
          }
          if (data.nextId != null) {
            this.nextId = data.nextId.id
            this.nextTitle = data.nextId.title
          }
        })
        .catch(error => {
          console.error("查询出错，原因是", error);
        });
    },
    fetchPathPreviousId(id) {
      // 根据 id 查询数据的逻辑
      fetch('https://mingqicaiwu.com:8201/admin/news/getTwoId', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${id}`
      })
        .then(response => response.json())
        .then(data => {
          // console.log("前一页和后一页data",data);
          this.handleClick(id, data.nextId, data.previousId)
        })
        .catch(error => {
          console.error("查询出错，原因是", error);
        });
    },
    handleClick(id) {
      const contentPageUrl = this.$router.resolve({ name: 'xinwen' }).href;
      const urlWithId = `${contentPageUrl}?id=${id}`;

      // 在新标签页打开带 id 的 URL
      window.location = urlWithId;
    },
    fetchPathNextId(id) {
      // 根据 id 查询数据的逻辑
      fetch('https://mingqicaiwu.com:8201/admin/news/getTwoId', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${id}`
      })
        .then(response => response.json())
        .then(data => {
          this.handleClick(id, data.nextId, data.previousId)
          // console.log("前一页和后一页data", data);
        })
        .catch(error => {
          console.error("查询出错，原因是", error);
        });
    },
    fetchDataById(id) {
      // 根据 id 查询数据的逻辑
      fetch('https://mingqicaiwu.com:8201/admin/news/selectById', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${id}`
      })
        .then(response => response.json())
        .then(data => {
          document.title = data.title;
          this.title = data.title
          this.formattedContent = data.content
          this.beforefont = data.beforefont
          this.fetchTwoId(id)
        })
        .catch(error => {
          console.error("查询出错，原因是", error);
        });
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen')
    },
    pathCompanyReg() {
      this.$router.push('/zhuce')
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathabout() {
      this.$router.push('/about')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
  },
};
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {

  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }
}
</style>

<style scoped>
/* 内容 */
.tiaozhuan {
  text-align: left;
  font-size: 18px;
  margin-bottom:0.83em;
  font-weight: 500;
}

.margintop {
  margin-top: 118px;
  margin-left: 25%;
  margin-right: 25%;
}

.titlecss {
  font-size: 18px;
  font-weight: bold;
}

h1 {
  font-size: 0%;
}

h2 {
  font-size: 20px;
  font-weight: 400;
}


@media (max-width: 768px) {
  /* 其他 */

  .tiaozhuan {
    text-align: left;
    font-size: 11px;
  }

  .margintop {
    margin-top: 100px;
    margin-left: 2%;
    margin-right: 2%;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/xinwen.vue